import {
  ApacCandidateHeader,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { getLanguageSwitcher } from '@seek/ca-myprofile-utils';
import { useMelwaysInfo } from '@seek/melways-react';
import { siteConfig } from '@seek/melways-sites';
import { useLocation } from 'react-router';

import type { UserProfile } from 'src/types';

import type { ApacHeaderFooterAuthenticationStatus } from '../App/App';

interface HeaderProps {
  authenticationStatus: ApacHeaderFooterAuthenticationStatus;
  userProfile: UserProfile;
}

const Header = ({ authenticationStatus, userProfile }: HeaderProps) => {
  const customLinkComponent = {
    sendLinkEvent: () => {},
  };
  const { pathname } = useLocation();
  const basePath = pathname.substring(pathname.indexOf('settings'));
  const { site } = useMelwaysInfo();
  const queryParams =
    typeof window !== 'undefined' ? window.location.search : '';
  const currentSiteConfigLanguages = siteConfig[site].languages;
  const languageSwitcher = getLanguageSwitcher(
    currentSiteConfigLanguages,
    basePath,
    queryParams,
  );

  return (
    <ApacCandidateHeaderFooterLinkProvider value={customLinkComponent}>
      <ApacCandidateHeader
        languageSwitcher={languageSwitcher}
        authenticationStatus={authenticationStatus}
        widthMode="large"
        userProfile={userProfile}
        activeAuthedUserTab="settings"
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};

export default Header;
